// test1738
(1738 && 0);
